EMRAdmin.service("CommonConfirmaionService", ['EMRCommonFactory', 'ModalPopupService', function (EMRCommonFactory, ModalPopupService) {

    /**
         * Function to open authentication popup
         * @returns {Promise} returns a promise which has authentication info
         */
    function showConfirmationPopup(message) {
        //calling Confirmation Popup
        return ModalPopupService.OpenPopup(GetEMRPageURLByIndex(50), message, 'md').then(function (result) {

            if (!result || result == 'NO')
                return undefined;
            else
                return "success";
        });
    }


    /**
     * Decorates a function with Confirmation Popup 
     * @param {Function} fn 
     */
    function confirmationDecorator(fn) {
        return function () {
            //get arguments
            var args = arguments;
            //validate whether confirmation message was present in arguments
            if (!args || !args[0] || !args[0].confirmationMessage)
                return;
            //assign confirmation message to local variable
            var confirmationMessage = args[0].confirmationMessage;

            //show confirmation popup and get call the fumction if returned success
            return showConfirmationPopup(confirmationMessage).then(function (response) {

                //if not confirmed by clicking no then do not allow the action
                if (!response) return;
                fn.apply(undefined, args)
            })
        }
    }

    Object.assign(this, { confirmationDecorator: confirmationDecorator });


}]);
